import React, { useState } from 'react';
import AccountsSelectbox from '../../../FormElements/AccountsSelectbox';

export default function CloneAccountCard(props) {
	// console.log('CloneAccountCard', props);

	return (
		<div className="CloneAccountCard p-2 mx-auto d-inline-block h-100">
			<div className="card border h-100">
				<div className="card-body w-100 text-center mx-auto px-4">
					<h1 className="card-title mx-auto mx-4">
						{I18n.t('admin.clone_account_title')}
					</h1>
					<hr />
					<span className="mb-3 d-block">
						{I18n.t('admin.clone_account_instructions')}
					</span>
					<div className="my-4 text-left">
						<AccountsSelectbox
							accounts_list_endpoint={props.accounts_list_endpoint}
							account_crud_api_key={props.account_crud_api_key}
							placeholder="Select an account"
							onChange={props.onChangeCloneExistingAccount}
						/>
					</div>
					<hr />
					<button
						type="button"
						className="btn btn-primary w-100 mt-2"
						onClick={() => {
							props.onHidePopup();
							props.onShowPopup();
						}}
					>
						{I18n.t('admin.clone_selected_account')}
					</button>
				</div>
			</div>
		</div>
	);
}
